let pdfjsPromise = null;

/**
 * Loads PDF.js on first use so the library stays out of the main bundle.
 * The worker is served from public/pdfjs (see scripts/copy-pdf-worker.js)
 * because the bundled copy breaks in production builds.
 */
const loadPdfjs = () => {
  if (!pdfjsPromise) {
    pdfjsPromise = import('pdfjs-dist/build/pdf').then((pdfjs) => {
      pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdfjs/pdf.worker.${pdfjs.version}.min.js`;
      return pdfjs;
    }).catch((error) => {
      pdfjsPromise = null;
      throw error;
    });
  }
  return pdfjsPromise;
};

export default loadPdfjs;
